import * as React from "react";
import { useState, useEffect, useContext, useRef } from "react";
import { AnyForNow, GrnData, GrnItem } from "./types";
import { useStyles } from "../../assets/styles/Theme";
import { useTheme } from "@mui/material/styles";
import SystemAlert from "../../components/common/SystemAlert";
import {
  Box,
  Typography,
  Button,
  Divider,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Tooltip,
} from "@mui/material";

import Grid from "@mui/material/Grid2";
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { PageDataContext } from "../../utils/common/PageDataContext";
import ViewGrnSupplier from "../../components/grn/ViewGrnSupplier";
import ViewGrnPo from "../../components/grn/ViewGrnPo";
import ViewGrnAttachments from "../../components/grn/ViewGrnAttachments";
import DisabledByDefaultOutlinedIcon from "@mui/icons-material/DisabledByDefaultOutlined";
import GrnPdf from "../../features/documents/GrnPdf";
import RejectionNotePdf from "../../features/documents/RejectionNotePdf";
import ReturnItemsTableview from "../../components/grn/ReturnItemsTableview";
import ReturnItemsTable from "../../components/grn/ReturnItemsTable";
import { GRN_API_01, GRN_API_09, GRN_API_09_1, GRN_API_16 } from "../../api/ApiModel";
import { externalgetApi, externalpostApi } from "../../services/externalApis";
import { useSelector } from "react-redux";
import GrnStatusHistory from "../../components/grn/GrnStatusHistory";
import ViewSidebarOutlinedIcon from "@mui/icons-material/ViewSidebarOutlined";
import {
  DOC_TYPE,
  GRN_ALERT_TYPE,
  GRN_CONSTRAINTS,
  GRN_DEFAULTS,
  GRN_DIALOG,
  GRN_RETURN_DEFAULTS,
  GRN_RETURN_STATUS,
  GRN_RETURN_UI,
  GRN_STORAGE_KEYS,
} from "../../utils/sys/GrnConstants";
import {
  GRN_SUCCESS_MESSAGES,
  GRN_ERROR_MESSAGES,
  GRN_FAILURE_MESSAGES,
  GRN_CONFIRM_MESSAGES,
} from "../../utils/sys/GrnValidation";
import { GRN_ROUTES } from "../../utils/sys/GrnRoutes";
import {
  BUTTON_LABELS,
  GRN_RETURN_LABELS,
  PAGE_TITLES,
} from "../../utils/sys/GrnLabels";
import { CON_BUSINESS_TYPECODE } from "../../utils/sys/Constants";
import ViewReturnGrnPo from "../../components/grn/ViewReturnGrnPo";
import ViewGrnRtnSupplier from "../../components/grn/ViewGrnRtnSupplier";
import ReturnItemsTableviewdet from "../../components/grn/ReturnItemsTableviewdet";

interface ReturnGrnProps {
  selectedSupplier?: AnyForNow;
  grnDetailsForm?: AnyForNow;
  grncode?: string;
  trcatcode?: string;
  origin?: string;
}

const 
ReturnGrn: React.FC<ReturnGrnProps> = ({  selectedSupplier, grnDetailsForm, }) => {
  const theme = useTheme();
  const styles = useStyles(theme);
  const location = useLocation();
  const navigate = useNavigate();
  const { setPageData } = useContext(PageDataContext);
  const rightSidebarRef = useRef<HTMLDivElement>(null);
  const [docType, setDocType] = useState<string>(GRN_DEFAULTS.STRING);
  const [confirmDialogOpen, setConfirmDialogOpen] = useState<boolean>(false);
  const [openPdf, setOpenPdf] = useState<boolean>(false);
  const SYS_USER = useSelector((state: AnyForNow) => state.user) || {};
  const { COMPCODE, STAFFMAPLOCODE } = SYS_USER.USER_PARAM || {};
 const { statusCode, origin } = location?.state || {};

   const moduleParamJson = useSelector((state: AnyForNow) => state.moduleParamJson);
  
  const PARAID = moduleParamJson && moduleParamJson[0]?.PARAID;
  const PARAVALUE = moduleParamJson && moduleParamJson[0]?.PARAVALUE;
console.log("moduleParamJson", moduleParamJson);
console.log("PARAID", PARAID);
console.log("PARAVALUE", PARAVALUE);

  const [returnedProducts, setReturnedProducts] = useState<AnyForNow[]>([]);
  const filterValidReturns = (products: AnyForNow[] = []): AnyForNow[] =>
    products.filter(
      (item) => item && Number(item.returnedqty) > GRN_DEFAULTS.NUMBER
    );
  const [trackingDetails, setTrackingDetails] = useState<AnyForNow[]>([]);
  const [Returncal,setReturncal] = useState<AnyForNow[]>([]);

  const { grncode, trsts, trcatcode } = location?.state || {};
  const [grnList, setGrnList] = useState<AnyForNow[]>([]);
  const [returns, setreturns] = useState<AnyForNow[]>([]);

  const [billingSummary, setBillingSummary] = useState<{
    grossAmount: number;
    discountAmount: number;
    taxableValue: number;
    netValue: number;
  }>({
    grossAmount: GRN_DEFAULTS.NUMBER,
    discountAmount: GRN_DEFAULTS.NUMBER,
    taxableValue: GRN_DEFAULTS.NUMBER,
    netValue: GRN_DEFAULTS.NUMBER,
  });

  const [rightSidebarOpen, setRightSidebarOpen] = useState<boolean>(false);
  // Toggle function
  const toggleRightSidebar = (): void => {
    setRightSidebarOpen((prev) => !prev);
  };
 // Set origin to "return" for ReturnItemsTable
  useEffect(() => {
    setPageData({
      title: PAGE_TITLES.RETURN_GRN,
      // icon: <HomeIcon />,
      // showBackButton: false,
      // customActions: <button>Refresh</button>,
      // breadcrumbs: ["Home", "Dashboard"],
    });
  }, []);

  const [alert, setAlert] = useState<{
    open: boolean;
    type: "error" | "success" | "info" | "warning";
    message: string;
  }>({
    open: false,
    type: GRN_ALERT_TYPE.SUCCESS,
    message: GRN_DEFAULTS.STRING,
  });

  const liveReturnSelectionRef = useRef<AnyForNow[]>([]);
  const [showSelectionValidationError, setShowSelectionValidationError] =
    useState(false);

  const handleAlertClose = (): void => {
    setAlert({ ...alert, open: false });
  };
  const handleCancelReturn = (): void => {
    navigate(GRN_ROUTES.RETURN_GRN);

  };

  useEffect(() => {
    if (grncode && trsts ) {
      fetchGrnData(grncode, trsts);
    } else {
      // console.warn("Missing grncode or trsts in location.state");
      // setAlertType("error");
      // setAlertMessage("Missing GRN code or status");
      // setAlertOpen(true);
    }
  }, [grncode, trsts]);

  const fetchGrnData = async (grncode: string, trsts: string | number): Promise<void> => {
    try {
      const result = await externalgetApi(GRN_API_01, "GET", {
        COMPCODE,
        // LOCCODE: STAFFMAPLOCODE,
        GRNCODE: grncode,
        STS: trsts,
      });
      setGrnList(result || []);
      setTrackingDetails(result?.[0]?.tracking || []);
      setreturns(result?.[0]?.returnList)

      //  setTrackingDetails(result?.[0]?.tracking || []);
    } catch (err) {
      console.error("Error fetching GRN data:", err);
    }
  };

  useEffect(() => {
    function handleClickOutside(event: MouseEvent): void {
      if (
        rightSidebarRef.current &&
        !rightSidebarRef.current.contains(event.target as Node) &&
        rightSidebarOpen
      ) {
        setRightSidebarOpen(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [rightSidebarOpen]);
  useEffect(() => {
    const storedProducts = localStorage.getItem(GRN_STORAGE_KEYS.RETURNED_PRODUCTS);
    // const storedBillingSummary = localStorage.getItem(GRN_STORAGE_KEYS.BILLING_SUMMARY);

    if (storedProducts) {
      const parsed = JSON.parse(storedProducts);
      const sanitized = filterValidReturns(parsed);
      setReturnedProducts(sanitized);
      // Clean up any zero-qty entries that might be lingering in storage
      if (sanitized.length !== parsed.length) {
        localStorage.setItem(
          GRN_STORAGE_KEYS.RETURNED_PRODUCTS,
          JSON.stringify(sanitized)
        );
      }
    }
    // console.log("storedProducts", storedProducts);
  }, []);

  const handleSaveReturnedProducts = ({ dtProductReturns }: { dtProductReturns: AnyForNow[] }): void => {
    const sanitized = filterValidReturns(dtProductReturns);
    const updatedProducts = sanitized;
    console.log("Local Storage : Returns :", updatedProducts);

    setReturnedProducts(updatedProducts);

    const totalGross = updatedProducts.reduce(
      (sum, item) => sum + item.grossAmount,
      GRN_DEFAULTS.NUMBER
    );
    const totalDiscount = updatedProducts.reduce(
      (sum, item) => sum + item.discount,
      GRN_DEFAULTS.NUMBER
    );
    const totalTaxableValue = updatedProducts.reduce(
      (sum, item) => sum + item.taxableValue,
      GRN_DEFAULTS.NUMBER
    );
    const totalNetValue = updatedProducts.reduce(
      (sum, item) => sum + item.netValue,
      GRN_DEFAULTS.NUMBER
    );

    setBillingSummary({
      grossAmount: totalGross,
      discountAmount: totalDiscount,
      taxableValue: totalTaxableValue,
      netValue: totalNetValue,
    });

    localStorage.setItem(
      GRN_STORAGE_KEYS.RETURNED_PRODUCTS,
      JSON.stringify(updatedProducts)
    );

    console.log("Showing return save success message:", GRN_SUCCESS_MESSAGES.RETURN_SAVE_SUCCESS);
    console.log("All GRN_SUCCESS_MESSAGES:", GRN_SUCCESS_MESSAGES);
    setAlert({
      open: true,
      type: GRN_ALERT_TYPE.SUCCESS,
      message: GRN_SUCCESS_MESSAGES.RETURN_SAVE_SUCCESS,
    });
  };

  console.log("returnedProducts", returnedProducts);
    const handleGoodsreturnprocess = async (): Promise<AnyForNow> => {
    const validReturnedProducts = liveReturnSelectionRef.current; 
  if (validReturnedProducts.length === 0) {
    setAlert({
      open: true,
      type: GRN_ALERT_TYPE.ERROR,
      message: GRN_ERROR_MESSAGES.NO_ITEMS,
    });
    throw new Error("No valid return items to process");
  }
  const grnReturnItems = validReturnedProducts.map((product) => ({
    grnprcode: product.grnprcode || GRN_DEFAULTS.NUMBER,
    supproductcode: parseInt(product.supproductcode) || GRN_DEFAULTS.NUMBER,
    returnedqty: product.returnedqty || GRN_DEFAULTS.NUMBER,
    unitcostwithouttax: GRN_DEFAULTS.NUMBER,
    taxperunit: GRN_DEFAULTS.NUMBER,
    taxamount: GRN_DEFAULTS.NUMBER,
    totalbeforetax: GRN_DEFAULTS.NUMBER,
    reason: GRN_DEFAULTS.STRING,
    descrip: GRN_DEFAULTS.STRING,
    docpathjson: GRN_DEFAULTS.STRING,
  }));

  const grnReturnSummaries = [
    {
      totreturnedvalue: GRN_DEFAULTS.NUMBER,
      tottaxamount: GRN_DEFAULTS.NUMBER,
      totalbeforetax: GRN_DEFAULTS.NUMBER,
    },
  ];

  const payload = {
    grncode: grncode,
    grnReturnItems,
    grnReturnSummaries,
  };

  console.log("xxx", payload);

  try {
    const response = await externalpostApi(GRN_API_16, payload);
    console.log("Response update:", response);
    setReturncal(response);
    setAlert({
      open: true,
      type: GRN_ALERT_TYPE.SUCCESS,
      message: `${grncode} ${GRN_SUCCESS_MESSAGES.RETURN_SUCCESS}`,
    });
    return response; // Ensure the response is returned
  } catch (error) {
    setAlert({
      open: true,
      type: GRN_ALERT_TYPE.ERROR,
      message: GRN_FAILURE_MESSAGES.RETURN_FAILED,
    });
    throw error; // Re-throw the error to handle it in the calling function
  }
};

  const handleConfirmReturn = async (): Promise<void> => {
    const validReturns = filterValidReturns(returnedProducts);
    if (!validReturns.length) {
      setAlert({
        open: true,
        type: GRN_ALERT_TYPE.ERROR,
        message: GRN_ERROR_MESSAGES.NO_ITEMS,
      });
      return;
    }

    const payload = {
      grndoccode: DOC_TYPE.REJECT,
      grncode: grncode,
      grnreturncode:"",
      descrip: GRN_DEFAULTS.STRING,
      compcode: COMPCODE,
      loccode: STAFFMAPLOCODE,
      businesstypecode: CON_BUSINESS_TYPECODE,
      enuser: SYS_USER?.USER_PARAM?.USERNAME || GRN_RETURN_DEFAULTS.ENUSER_FALLBACK,
      sts: GRN_RETURN_STATUS.RETURNED,
      dtProductReturns: validReturns,
    };

    try {
      const response = await externalpostApi(GRN_API_09_1, payload);
      console.log("Response from GRN update:", response);
      setAlert({
        open: true,
        type: GRN_ALERT_TYPE.SUCCESS,
        message: GRN_SUCCESS_MESSAGES.RETURN_SUCCESS,
      });
      setTimeout(() => {
        navigate(GRN_ROUTES.RETURN_GRN, { replace: true });
      }, GRN_CONSTRAINTS.DEFAULT_WAIT_TIME);
    } catch (error) {
      setAlert({
        open: true,
        type: GRN_ALERT_TYPE.ERROR,
        message: GRN_FAILURE_MESSAGES.RETURN_FAILED,
      });
    }
  };
const hasCheckedRowsRef = useRef<boolean>(false);
 
const handleNext = async (): Promise<void> => {
  setShowSelectionValidationError(true);
  const validReturns = liveReturnSelectionRef.current;

  if (!hasCheckedRowsRef.current) {
    setAlert({
      open: true,
      type: GRN_ALERT_TYPE.ERROR,
      message: "Please enter return details for at least one item.",
    });
    return;
  }

  // Case 2: Checkboxes ticked but return quantity not entered
  if (!validReturns || validReturns.length === 0) {
    setAlert({
      open: true,
      type: GRN_ALERT_TYPE.ERROR,
      message: "Please enter a return quantity for the selected items.",
    });
    return;
  }

    localStorage.setItem(
    GRN_STORAGE_KEYS.RETURNED_PRODUCTS,
    JSON.stringify(validReturns)
  );

  try {
    const Returncalresponse = await handleGoodsreturnprocess();
    setShowSelectionValidationError(false);

    navigate(GRN_ROUTES.VIEW_RETURN_DETAIL, {
      state: {
        returnedProducts: validReturns,   // ← already correct
        grncode,
        trsts,
        billingSummary,
        Returncal: Returncalresponse,
      },
    });
  } catch (error) {
    console.error("Error during goods return process:", error);
    setAlert({
      open: true,
      type: GRN_ALERT_TYPE.ERROR,
      message: GRN_FAILURE_MESSAGES.RETURN_FAILED,
    });
  }
};

  const handleSave = async (): Promise<void> => {
      setShowSelectionValidationError(true);
      const validReturns = liveReturnSelectionRef.current; 
      if (!hasCheckedRowsRef.current) {
    setAlert({
      open: true,
      type: GRN_ALERT_TYPE.ERROR,
      message: "Please enter return details for at least one item.",
    });
    return;
  }

  // Case 2: Checkboxes ticked but return quantity not entered
  if (!validReturns || validReturns.length === 0) {
    setAlert({
      open: true,
      type: GRN_ALERT_TYPE.ERROR,
      message: "Please enter a return quantity for the selected items.",
    });
    return;
  }
  
    // Get PARAID and PARAVALUE from Redux
    const PARAID = moduleParamJson?.[0]?.PARAID;
    const PARAVALUE = moduleParamJson?.[0]?.PARAVALUE;
  
    // Conditionally set sts
  //  const stsValue = PARAVALUE === 24 && (PARAID === "N" || PARAID === 0) ? "8" : "7";
  
  
    const payload = {
      grndoccode: DOC_TYPE.REJECT,
      grncode: grncode,
          grnreturncode:"",
      descrip: GRN_DEFAULTS.STRING,
      reason: GRN_DEFAULTS.STRING,
      compcode: COMPCODE,
      loccode: STAFFMAPLOCODE,
      businesstypecode: CON_BUSINESS_TYPECODE,
      enuser: SYS_USER?.USER_PARAM?.USERNAME || GRN_RETURN_DEFAULTS.ENUSER_FALLBACK,
      sts: GRN_RETURN_STATUS.DRAFT,
      TRSTS: GRN_RETURN_STATUS.DRAFT,
      dtProductReturns: validReturns,
      dtoReturnDOCs: [
        {
          doctypecode: DOC_TYPE.DEFAULT,
          doctypeothername: GRN_DEFAULTS.STRING,
          docpathjson: GRN_DEFAULTS.STRING,
          filename: GRN_DEFAULTS.STRING,
          bytarr: GRN_DEFAULTS.STRING,
          remark: GRN_DEFAULTS.STRING,
        },
      ],
    };
  
    console.log("Payload for GRN return:", payload);
  
    try {
      const response = await externalpostApi(GRN_API_09_1, payload);
      console.log("✅ Response from GRN return save:", response);
      console.log("✅ About to navigate to GRN_ROUTES.RETURN_GRN which is:", GRN_ROUTES.RETURN_GRN);
  
      setAlert({
        open: true,
        type: GRN_ALERT_TYPE.SUCCESS,
        message: GRN_SUCCESS_MESSAGES.RETURN_SAVE_SUCCESS,
      });
      setShowSelectionValidationError(false);

      setTimeout(() => {
        console.log("⏱️ 2-second delay completed, navigating to:", GRN_ROUTES.RETURN_GRN);
        navigate(GRN_ROUTES.RETURN_GRN);
      }, GRN_CONSTRAINTS.DEFAULT_WAIT_TIME);
    } catch (error) {
      console.error("❌ Error updating GRN:", error);
      console.error("❌ Error details:", {
        status: error?.response?.status,
        statusText: error?.response?.statusText,
        data: error?.response?.data,
        message: error?.message,
      });
      setAlert({
        open: true,
        type: GRN_ALERT_TYPE.ERROR,
        message: GRN_FAILURE_MESSAGES.UPDATE_FAILED,
      });
    }
  };

  return (
    <>
      <Box
        ref={rightSidebarRef}
        sx={{
          position: "fixed",
          top: GRN_RETURN_UI.SIDEBAR_TOP,
          right: rightSidebarOpen ? 0 : GRN_RETURN_UI.SIDEBAR_HIDDEN_OFFSET,
          width: {
            xs: GRN_RETURN_UI.SIDEBAR_WIDTH_MOBILE,
            sm: GRN_RETURN_UI.SIDEBAR_WIDTH,
          },
          height: "100vh",
          bgcolor: "background.paper",
          boxShadow: 3,
          p: 1,
          zIndex: (theme) => theme.zIndex.drawer + 1,
          transition: GRN_RETURN_UI.SIDEBAR_TRANSITION,
          pointerEvents: "auto", // sidebar accepts pointer events
          display: "flex",
          flexDirection: "column",
          overflowY: "auto",
          scrollbarWidth: "none", // Hide scrollbar in Firefox
          "&::-webkit-scrollbar": {
            display: "none", // Hide scrollbar in WebKit browsers
          },
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",

            alignItems: "center",
            my: 1,
          }}
        >
          <Typography variant="h6">{GRN_RETURN_LABELS.TRACKING_TITLE}</Typography>
          <IconButton
            onClick={toggleRightSidebar}
            size="small"
            aria-label="close sidebar"
          >
            <DisabledByDefaultOutlinedIcon />
          </IconButton>
        </Box>
        <Divider />
        <Box
          sx={{
            flexGrow: 1,
            overflowY: "auto",
            scrollbarWidth: "none", // Hide scrollbar in Firefox
            "&::-webkit-scrollbar": {
              display: "none", // Hide scrollbar in WebKit browsers
            },
          }}
        >
          <GrnStatusHistory
            trackingDetails={trackingDetails}
            grncode={grncode}
          />
        </Box>
      </Box>
      <Box sx={styles.grn_supplier_container}>
        <Grid container spacing={2}>
          <Grid
            size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <Typography sx={styles.title_text}>
             PURCHASE RETURN -
             GRN ID {grncode}
            </Typography>
            
            <Tooltip title={GRN_RETURN_LABELS.VIEW_HISTORY}>
              <IconButton
                onClick={toggleRightSidebar}
                // disabled={statusCode === 3}
              >
                <ViewSidebarOutlinedIcon />
              </IconButton>
            </Tooltip>
          </Grid>

          <Grid size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
            <Divider />
          </Grid>
          <Grid size={{ xs: 12, sm: 6, md: 6, lg: 6, xl: 6 }}>
            <Box
              sx={{
                width: {
                  xs: "80%",
                  sm: "80%",
                  md: "50%",
                  lg: "50%",
                  xl: "50%",
                },
              }}
            >
              < ViewGrnRtnSupplier
                onOpenSidebar={toggleRightSidebar}
                selectedSupplier={selectedSupplier}
                statusCode={String(statusCode)}
                // grnHeader={grnHeader}
                grnHeader={grnList.length > 0 ? grnList[0].header : null}
                grncode={grncode}
                             
              />
            </Box>
          </Grid>

          <Grid
            size={{ xs: 12, sm: 6, md: 6, lg: 6, xl: 6 }}
            sx={{
              width: "50%",
              display: "flex",
              justifyItems: "flex-end",
              justifyContent: "flex-end",
            }}
          >
            <Box
              sx={{
                width: {
                  xs: "80%",
                  sm: "80%",
                  md: "50%",
                  lg: "50%",
                  xl: "50%",
                },
                display: "flex",
                justifyItems: "flex-end",
              }}
            >
              <ViewReturnGrnPo
                grnDetailsForm={grnDetailsForm}
                grnHeader={grnList.length > 0 ? grnList[0].header : null}
                grncode={grncode}
              />
            </Box>
          </Grid>
        </Grid>
      </Box>
      <Box sx={{ my: 2 }}>
          {/* <ReturnItemsTable
          items={grnList.length > 0 ? grnList[0].products : null}
          grncode={grncode}
          setReturnedProducts={setReturnedProducts}
          onSave={handleSaveReturnedProducts}
        /> */}
        {/* <ReturnItemsTableview
          items={grnList.length > 0 ? grnList[0].products : null}
          grncode={grncode}
          setReturnedProducts={setReturnedProducts}
          onSave={handleSaveReturnedProducts}
          trsts={trsts}
        /> */}
        <ReturnItemsTableviewdet
  items={grnList.length > 0 ? grnList[0].products : null}
  grncode={grncode}
  setReturnedProducts={setReturnedProducts}
  onSave={handleSaveReturnedProducts}
  trsts={trsts}
  trcatcode={trcatcode}
  returns={returns}
  onSelectionChange={(items) => {
    liveReturnSelectionRef.current = items;
  }}
  onCheckedRowsChange={(hasChecked) => {
    hasCheckedRowsRef.current = hasChecked;
  }}
  origin={origin}
  showSelectionValidationError={showSelectionValidationError}
/>
      </Box>

      {/* Attachenments and price */}
      <Box pt={2} sx={styles.grn_search_container}>
        <Grid container spacing={6}>
          <Grid size={{ xs: 12, sm: 6, md: 6, lg: 6, xl: 6 }}>
            {/* <Typography sx={styles.grn_sub_title_text} gutterBottom>
              Attached Documents:
            </Typography>
            <Divider /> */}
            <ViewGrnAttachments />
          </Grid>
       

     
    

          <Grid
            size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              gap: 2,
            }}
          >
            <Button
              variant="outlined"
              color="primary"
              size="small"
              sx={{ ...styles.btn_secondary }}
              onClick={handleCancelReturn}
            >
              {BUTTON_LABELS.CANCEL}
            </Button>
     <Button
              variant="contained"
              color="primary"
              size="small"
              sx={{ ...styles.btn_primary }}
              onClick={handleSave}
            >
             {BUTTON_LABELS.SAVE}
            </Button>
            <Button
              variant="contained"
              color="primary"
              size="small"
              sx={{ ...styles.btn_primary }}
              onClick={handleNext}
            >
              {BUTTON_LABELS.NEXT}
            </Button>
          </Grid>
        </Grid>
      </Box>
      <Divider />

      <Dialog
        open={openPdf}
        onClose={() => setOpenPdf(false)}
        fullWidth
        maxWidth={GRN_DIALOG.PREVIEW_MAX_WIDTH}
      >
        <DialogTitle>
          {docType} {GRN_RETURN_LABELS.PREVIEW_SUFFIX}
          <IconButton
            aria-label="close"
            onClick={() => setOpenPdf(false)}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <DisabledByDefaultOutlinedIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent dividers>
          {docType === GRN_RETURN_LABELS.REJECTION_NOTE ? (
            <RejectionNotePdf docType={docType} />
          ) : (
            <GrnPdf docType={docType} />
          )}
        </DialogContent>
      </Dialog>
      <Dialog
        open={confirmDialogOpen}
        onClose={() => setConfirmDialogOpen(false)}
        fullWidth
        maxWidth={GRN_DIALOG.MAX_WIDTH}
      >
        <DialogTitle>
          {BUTTON_LABELS.CONFIRM} {BUTTON_LABELS.RETURN}
        </DialogTitle>
        <DialogContent>
          <Typography>
            {GRN_CONFIRM_MESSAGES.RETURN_GRN}
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button
            variant="outlined"
            color="primary"
            sx={{ textTransform: "capitalize" }}
            onClick={() => setConfirmDialogOpen(false)} // Close the dialog
          >
            {BUTTON_LABELS.CANCEL}
          </Button>
          <Button
            variant="contained"
            color="primary"
            sx={{ ...styles.btn_primary }}
            onClick={() => {
              setConfirmDialogOpen(false); // Close the dialog
              handleConfirmReturn(); // Call the confirm return function
            }}
          >
            {BUTTON_LABELS.CONFIRM}
          </Button>
        </DialogActions>
      </Dialog>
      <SystemAlert
        open={alert.open}
        type={alert.type}
        message={alert.message}
        onClose={handleAlertClose}
      />
    </>
  );
};

export default ReturnGrn;
